const GetTranslation = {
  methods: {
    getTranslationObject(item, lang = this.lang) {
      // Find object by language parameter, e.g. en => type: 'en'
      const object = item.find((x) => x.lang === lang)
      return object
    },
  },
}

export default GetTranslation
